
    <h1>복리후생</h1>
    <h2>AIROV의 가장 큰 자산, 구성원들을 위한 혜택</h2>
    <div class="list-wrap">
        <div class="welfare">
            <div class="img">
                <img data-aos="flip-left" src="/assets/images/welfare01.png">
            </div>
            <div class="text">
                <dl>
                    <dt>월요병 방지제도</dt>
                    <dd>· 월요일 오전 11시 출근</dd>
                </dl>
            </div>
        </div>

        <div class="welfare">
            <div class="img">
                <img data-aos="flip-left" src="/assets/images/welfare02.png">
            </div>
            <div class="text">
                <dl>
                    <dt>휴가 제도</dt>
                    <dd>· 하기 휴가</dd>
                    <dd>· 연차제도 활성화</dd>

                </dl>
            </div>
        </div>

        <div class="welfare">
            <div class="img">
                <img data-aos="flip-left" src="/assets/images/welfare03.png">
            </div>
            <div class="text">
                <dl>
                    <dt>장기근속자 포상</dt>
                    <dd>· 유급 휴가 지원</dd>
                    <dd>· 휴가 경비 지급</dd>
                </dl>
            </div>
        </div>
    </div>
    <div class="list-wrap02">
        <div class="welfare">
            <div class="img">
                <img data-aos="flip-left" src="/assets/images/welfare04.png">
            </div>
            <div class="text">
                <dl>
                    <dt>경조사 지원</dt>
                    <dd>· 경조금 지급</dd>
                    <dd>· 경조휴가 지원</dd>
                </dl>
            </div>
        </div>

        <div class="welfare">
            <div class="img">
                <img data-aos="flip-left" src="/assets/images/welfare05.png">
            </div>
            <div class="text">
                <dl>
                    <dt>명절 지원</dt>
                    <dd>· 설, 추석 상여금 지원</dd>
                </dl>
            </div>
        </div>

        <div class="welfare">
            <div class="img">
                <img data-aos="flip-left" src="/assets/images/welfare06.png">
            </div>
            <div class="text">
                <dl class="last">
                    <dt>각종 편의 지원</dt>
                    <dd>· 조식,중식 제공</dd>
                    <dd>· 주차비 일부 지원</dd>
                    <dd>· 구성원 회식비 지원</dd>
                </dl>
            </div>
        </div>
    </div>
